// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__270sL","vLegacy":"SelectSecondary_vLegacy__1NhhD","error":"SelectSecondary_error__jQ1R3","disabled":"SelectSecondary_disabled___ASjW"};